"use client";

import { usePathname } from "next/navigation";
import SecondaryHeader from "./secondaryHeader";

export default function SecondaryHeaderClient() {
  const pathname = usePathname();

  return <SecondaryHeader pathname={pathname ?? ""} />;
}
